import { ApiResult, request, safeRequest } from '@synergy/api';

import { SupplierConditions } from '../models/supplier-conditions';
import { SupplierConditionsRequest } from './models/supplier-conditions-request';
import { Term } from '../models/term';
import { TermRequestValue } from './models/term-request-value';

export class SupplierConditionsApi {
    constructor(protected baseUrl: string) {}

    public getConditions(supplierId: number): Promise<ApiResult<SupplierConditions>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/suppliers/${supplierId}/conditions`),
            response => response.data
        );
    }

    public updateConditions(
        supplierId: number,
        updateRequest: SupplierConditionsRequest
    ): Promise<ApiResult<SupplierConditions>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/suppliers/${supplierId}/conditions`, updateRequest),
            response => response.data
        );
    }

    public getDeliveryTerms(): Promise<ApiResult<Term[]>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/delivery-terms`),
            response => response.data
        );
    }

    public updateDeliveryTerms(deliveryTerms: TermRequestValue[]): Promise<ApiResult<Term[]>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/update-delivery-terms`, { deliveryTerms }),
            response => response.data
        );
    }
}
